const copyText = (textToCopy: string) => {
  navigator.clipboard.writeText(`${textToCopy}`);
};

export default copyText;
